export const getFormattedPersonalNumber = (personalNumber: string) => {
  if (personalNumber && personalNumber.includes('-')) return personalNumber;
  return personalNumber
    ? `${personalNumber.substring(0, 8)}-${personalNumber.substring(8)}`
    : '';
};
